import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LogIn } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email.trim().toLowerCase(), password);
      const from = location.state?.from?.pathname || "/";
      navigate(from, { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(formatApiError(detail) || "Autentificare esuata");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-slate-100 px-4">
      <form
        data-testid="login-form"
        onSubmit={onSubmit}
        className="w-full max-w-sm rounded-xl border border-slate-200 bg-white p-6 shadow-2xl"
      >
        <div className="mb-6 flex items-center gap-3">
          <div className="h-9 w-9 rounded bg-accent-500 text-ink-950 grid place-items-center font-bold">A</div>
          <div>
            <div className="text-xs uppercase tracking-widest text-slate-500">AmeMan</div>
            <div className="text-base font-semibold">Acces management</div>
          </div>
        </div>
        <label className="block text-sm text-slate-600 mb-1" htmlFor="email">Email</label>
        <input
          data-testid="login-email-input"
          id="email"
          type="email"
          required
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mb-4 w-full rounded border border-slate-200 bg-slate-100 px-3 py-2 outline-none focus:border-accent-500"
        />
        <label className="block text-sm text-slate-600 mb-1" htmlFor="password">Parola</label>
        <input
          data-testid="login-password-input"
          id="password"
          type="password"
          required
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mb-6 w-full rounded border border-slate-200 bg-slate-100 px-3 py-2 outline-none focus:border-accent-500"
        />
        <button
          data-testid="login-submit-btn"
          type="submit"
          disabled={submitting}
          className="inline-flex w-full items-center justify-center gap-2 rounded bg-accent-500 px-4 py-2 font-semibold text-ink-950 hover:bg-accent-600 disabled:opacity-60"
        >
          <LogIn size={16} /> {submitting ? "Conectare..." : "Conectare"}
        </button>
        <p className="mt-4 text-center text-xs text-slate-400">
          Acces restrictionat. Conturile sunt create de Board.
        </p>
      </form>
    </div>
  );
}
